module.exports = __webpack_public_path__ + "static/media/SF-2-A.35a47ce7.mp3";